import { Box, Stack } from '@mui/material';
import { useGetGuestJourneyChurnCardsQuery } from 'api/reports-service/guest-journey-hooks';
import {
  useGetGuestJourneyChurnedGridQuery,
  useGetGuestJourneyChurnedMemberTrendsQuery,
  useGetGuestJourneyChurnedTrendsQuery,
} from 'api/reports-service/guest-journey-reports';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import MemberCountTrends from '../active-customers/member-count-trends.component';
import {
  locationsOnlyFilteredSearchParams,
  memberTrendsFilteredSearchParams,
  useChurnedSearchParams,
} from '../guest-journey.hooks';
import ReportFieldsLink from '../report-fields/report-fields-link.component';
import ChurnedGrid from './churned-grid.component';
import ChurnedSummaryCards from './churned-summary-cards.component';
import ChurnedVioTrends from './churned-vio-trends.component';

/**
 * Queries only send the params on this tab's filter bar (Locations); the
 * Member Count Trends chart additionally sends its chart-scoped date range.
 */
const filteredSearchParams = locationsOnlyFilteredSearchParams;

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useChurnedSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <Churned />
    </SearchParamsProvider>
  );
};

const Churned = () => {
  const summary = useSearchQuery(useGetGuestJourneyChurnCardsQuery, {
    filteredSearchParams,
  });
  const vioTrends = useSearchQuery(useGetGuestJourneyChurnedTrendsQuery, {
    filteredSearchParams,
  });
  const grid = useSearchQuery(useGetGuestJourneyChurnedGridQuery, {
    filteredSearchParams,
  });
  const memberTrends = useSearchQuery(
    useGetGuestJourneyChurnedMemberTrendsQuery,
    {
      filteredSearchParams: memberTrendsFilteredSearchParams,
    },
  );

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            summary,
            vioTrends,
            grid,
            memberTrends,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />

          <ReportFieldsLink tab="churned" />

          <ChurnedSummaryCards
            data={summary.data}
            loading={summary.queryState.isFetching}
          />

          <ChurnedVioTrends
            trends={vioTrends.data?.trends}
            loading={vioTrends.queryState.isFetching}
          />

          <Box display="grid" gap={2} gridTemplateColumns={{ lg: '1fr 1fr' }}>
            <ChurnedGrid
              data={grid.data}
              loading={grid.queryState.isFetching}
            />

            <MemberCountTrends
              data={memberTrends.data}
              loading={memberTrends.queryState.isFetching}
              getTitle={t =>
                t('page.guestJourney.churned.memberCountTrendsChart.title')
              }
              data-testid="Churned.MemberCountTrends"
            />
          </Box>
        </Stack>
      </MultipleSearchQueryProvider>
    </Stack>
  );
};

export default SearchParamsWrapper;
